export default "__VITE_PUBLIC_ASSET__df06eec8__"